/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceTransactionType,
  BalanceTransactionTypeOptional,
  BalanceTransactionTypeMetaI,
  BalanceTransactionTypeTrackedI,
} from "./balance-transaction-type";
import {
  BalanceTransactionTypeTracked,
  BalanceTransactionTypeMeta,
} from "./balance-transaction-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableWithoutClose,
  PurchasableWithoutCloseOptional,
  PurchasableWithoutCloseMetaI,
  PurchasableWithoutCloseTrackedI,
} from "./purchasable-without-close";
import {
  PurchasableWithoutCloseTracked,
  PurchasableWithoutCloseMeta,
} from "./purchasable-without-close";

/**
 *
 * @export
 * @interface BalanceTransactionBase
 */
export interface BalanceTransactionBaseOptional extends PurchasableWithoutCloseOptional {
  /**
   *
   * @type {PurchasableState}
   * @memberof BalanceTransactionBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {BalanceTransactionType}
   * @memberof BalanceTransactionBase
   */
  balanceTransactionType?: BalanceTransactionType;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionBase
   */
  transactionAmountCents?: number;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionBase
   */
  transactionDateTime?: Date;
}

export interface BalanceTransactionBase
  extends BalanceTransactionBaseOptional, PurchasableWithoutClose {
  /**
   *
   * @type {PurchasableState}
   * @memberof BalanceTransactionBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {BalanceTransactionType}
   * @memberof BalanceTransactionBase
   */
  balanceTransactionType?: BalanceTransactionType;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionBase
   */
  transactionAmountCents: number;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionBase
   */
  transactionDateTime?: Date;
}

export interface BalanceTransactionBaseTrackedI extends PurchasableWithoutCloseOptional {
  /**
   *
   * @type {PurchasableState}
   * @memberof BalanceTransactionBase
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionBase
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {BalanceTransactionType}
   * @memberof BalanceTransactionBase
   */
  balanceTransactionType?: BalanceTransactionType;
  balanceTransactionTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionBase
   */
  transactionAmountCents?: number;
  transactionAmountCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionBase
   */
  transactionDateTime?: Date;
  transactionDateTimeIsSet: boolean;
}

transformDatesMap.set(
  "BalanceTransactionBase",
  function (model: BalanceTransactionBase) {
    if (typeof model.purchaseDate == "string")
      model.purchaseDate = new Date(model.purchaseDate);
    if (typeof model.transactionDateTime == "string")
      model.transactionDateTime = new Date(model.transactionDateTime);
  },
);

export type BalanceTransactionBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  balanceTransactionType: PropertyMeta<BalanceTransactionTypeMetaI>;
  //isDate: false
  //isDatetime: false
  transactionAmountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  transactionDateTime: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var BalanceTransactionBaseMeta: BalanceTransactionBaseMetaI =
  {} as BalanceTransactionBaseMetaI;
BalanceTransactionBaseMeta = typeMeta("BalanceTransactionBase", {
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  balanceTransactionType: propertyMeta(
    "balanceTransactionType",
    false,
    false,
    false,
    BalanceTransactionTypeMeta,
  ),
  transactionAmountCents: propertyMeta(
    "transactionAmountCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  transactionDateTime: propertyMeta(
    "transactionDateTime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = BalanceTransactionBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PurchasableWithoutCloseMeta]);
  metaI.purchasableState.inheritedFrom =
    PurchasableWithoutCloseMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = PurchasableWithoutCloseMeta.purchaseDate;
});

export class BalanceTransactionBaseTracked
  extends PurchasableWithoutCloseTracked
  implements BalanceTransactionBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  balanceTransactionType__I?: BalanceTransactionType = undefined;
  balanceTransactionTypeIsSet: boolean = false;
  set balanceTransactionType(v: undefined | BalanceTransactionType) {
    if (v !== undefined) {
      this.balanceTransactionType__I = v;
      this.balanceTransactionTypeIsSet = true;
    } else {
      this.balanceTransactionType__I = v || undefined;
      this.balanceTransactionTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceTransactionType() {
    return this.balanceTransactionType__I;
  }
  transactionAmountCents__I?: number = undefined;
  transactionAmountCentsIsSet: boolean = false;
  set transactionAmountCents(v: undefined | number) {
    if (v !== undefined) {
      this.transactionAmountCents__I = v;
      this.transactionAmountCentsIsSet = true;
    } else {
      this.transactionAmountCents__I = v || undefined;
      this.transactionAmountCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get transactionAmountCents() {
    return this.transactionAmountCents__I;
  }
  transactionDateTime__I?: Date = undefined;
  transactionDateTimeIsSet: boolean = false;
  set transactionDateTime(v: undefined | Date) {
    if (v !== undefined) {
      this.transactionDateTime__I = v;
      this.transactionDateTimeIsSet = true;
    } else {
      this.transactionDateTime__I = v || undefined;
      this.transactionDateTimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionDateTime() {
    return this.transactionDateTime__I;
  }
  constructor(
    config?: BalanceTransactionBaseOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: BalanceTransactionBaseOptional,
    options?: AssignOptions,
  ): BalanceTransactionBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.balanceTransactionType &&
      this.balanceTransactionTypeApplyFilter(optionsRequired.filter)
    ) {
      this.balanceTransactionType = config.balanceTransactionType;
      if (optionsRequired.unassign) this.balanceTransactionTypeIsSet = false;
      else this.balanceTransactionTypeIsSet = true;
    }
    if (
      config.transactionAmountCents &&
      this.transactionAmountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.transactionAmountCents = config.transactionAmountCents;
      if (optionsRequired.unassign) this.transactionAmountCentsIsSet = false;
      else this.transactionAmountCentsIsSet = true;
    }
    if (
      config.transactionDateTime &&
      this.transactionDateTimeApplyFilter(optionsRequired.filter)
    ) {
      this.transactionDateTime = config.transactionDateTime;
      if (optionsRequired.unassign) this.transactionDateTimeIsSet = false;
      else this.transactionDateTimeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): BalanceTransactionBaseTrackedI {
    const cloned = {} as BalanceTransactionBaseTrackedI;
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.balanceTransactionTypeIsSetDeep() &&
      this.balanceTransactionTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceTransactionTypeIsSet = true;
      cloned.balanceTransactionType = this.balanceTransactionType;
    } else {
      //cloned.balanceTransactionTypeIsSet = false
    }
    if (
      this.transactionAmountCentsIsSetDeep() &&
      this.transactionAmountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionAmountCentsIsSet = true;
      cloned.transactionAmountCents = this.transactionAmountCents;
    } else {
      //cloned.transactionAmountCentsIsSet = false
    }
    if (
      this.transactionDateTimeIsSetDeep() &&
      this.transactionDateTimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionDateTimeIsSet = true;
      cloned.transactionDateTime = this.transactionDateTime;
    } else {
      //cloned.transactionDateTimeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): BalanceTransactionBaseTrackedI {
    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.balanceTransactionTypeApplyFilter(filter))
      this.balanceTransactionTypeIsSet = false;

    if (!this.transactionAmountCentsApplyFilter(filter))
      this.transactionAmountCentsIsSet = false;

    if (!this.transactionDateTimeApplyFilter(filter))
      this.transactionDateTimeIsSet = false;

    return this;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionBaseMeta.purchasableState,
      BalanceTransactionBaseMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionBaseMeta.purchaseDate,
      BalanceTransactionBaseMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  balanceTransactionTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionBaseMeta.balanceTransactionType,
      BalanceTransactionBaseMeta,
      this.balanceTransactionType,
      this,
    );
  }
  balanceTransactionTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceTransactionTypeIsSet &&
      this.balanceTransactionTypeApplyFilter(filter)
    )
      return true;

    return false;
  }
  transactionAmountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionBaseMeta.transactionAmountCents,
      BalanceTransactionBaseMeta,
      this.transactionAmountCents,
      this,
    );
  }
  transactionAmountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionAmountCentsIsSet &&
      this.transactionAmountCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  transactionDateTimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionBaseMeta.transactionDateTime,
      BalanceTransactionBaseMeta,
      this.transactionDateTime,
      this,
    );
  }
  transactionDateTimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionDateTimeIsSet &&
      this.transactionDateTimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.balanceTransactionTypeIsSetDeep(filter)) return true;
    if (this.transactionAmountCentsIsSetDeep(filter)) return true;
    if (this.transactionDateTimeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
